import { useTranslation } from 'react-i18next';
import Hero640 from '../../assets/images/hero-640.webp';
import Hero1018 from '../../assets/images/hero-1018.webp';
import Hero2036 from '../../assets/images/hero-2036.webp';
import Logo from '../../assets/images/logo-make-skin.webp';

// children: conteúdo exibido abaixo do logotipo, na coluna escura (ex.: login)
export default function Header({ compact = false, showFacts = true, children }) {
  const [t] = useTranslation();
  return (
    <header className={`hero ${compact ? 'hero--compact' : ''} ${children ? 'hero--with-content' : ''}`}>
      <img
        alt=''
        src={Hero1018}
        srcSet={`${Hero640} 640w, ${Hero1018} 1018w, ${Hero2036} 2036w`}
        sizes='(min-width: 992px) 60vw, 100vw'
        width='1018'
        height='959'
        fetchpriority='high'
        className='hero__img'
      />
      <div className='hero__inner'>
        <div className='hero__brand'>
          <h1 className='hero__title'>
            <img
              alt={`${t('event.name')} – ${t('event.tagline')}`}
              src={Logo}
              width='472'
              height='520'
              className='hero__logo'
            />
          </h1>
          {showFacts && (
            <div className='facts'>
              <div className='fact'>
                <small>{t('event.facts.location')}</small>
                {t('event.address')}
                {' · '}
                <a
                  href={t('event.location.link')}
                  target='_blank'
                  rel='noreferrer'
                >
                  {t('event.location.text')}
                </a>
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </header>
  );
}
